import { h, Component } from 'preact';

import Textfield from 'q-mdc/quikr/core/text-field';
import ListItem from 'q-mdc/elements/material-list-item';
import List from 'q-mdc/elements/material-list';
import Button from 'q-mdc/elements/material-button';
import Otp from '../../otp';
import gtmLoader from '../../../../utils/GTMHelper';
import { isMobileValid, isRequired,isValidPincode, isEmailValid, pushToDataLayer, loadGA } from '../../../../utils/CommonHelper';
import apiCalls from '../../../../utils/FetchHelper';
import { apiUrl } from '../../../../config';

import "./index.scss";

class PartnershipForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            values: {
                salutation: 'Mr.',
            },
            errors: {},
            success: false,
            showOtpForm: false
        };
        this.validators ={};
        this.apiHelper = new apiCalls();
    }
    componentDidMount() {
        const gtm = new gtmLoader();
        gtm.GTMCall();
        loadGA();
        pushToDataLayer({event: this.props.formData.event});
        this.props.formData.textFields.map((data) => {
            if(data.isRequired) {
                this.setState(prevState => ({
                    errors: {
                        ...prevState.errors,
                        [data.name]: null
                    }
                }));
                if(data.name == 'mobile') {
                    this.validators[data.name] = [isMobileValid];
                } else if (data.name == 'email') {
                   this.validators[data.name] = [isEmailValid];
                } else if(data.name == 'pincode') {
                    this.validators[data.name] = [isValidPincode];
                }
                 else {
               this.validators[data.name] = [isRequired];
                }
            }
        });
    }

    onInput = (field) => {
        return (event) => {
            const hasError = Boolean(this.validators[field] && this.validators[field].every(validator => validator(event.target.value)));
            this.setState({
                errors: {
                    ...this.state.errors,
                    [field]: hasError,
                },
                values: {
                    ...this.state.values,
                    [field]: event.target.value,
                },
            });
        };
    }
    backBtn = () => {
        this.setState({
            showOtpForm: false,
            success: false
        });
    }
    submitForm = (event) => {
        event.preventDefault();
        const  { values, errors } = this.state;
        let errorCheck = false;
        Object.keys(errors).map((keys) => {
            if(!values[keys] || values[keys] === '' || errors[keys]) {
                this.setState(prevState => ({
                errors: {
                    ...prevState.errors,
                    [keys]: true
                }
            }));
            
            errorCheck = true;
        }
        });
        if(!errorCheck) {
            const res = this.state.values.name.split(" ");;
            const firstNamee = res.splice(0,1).toString();
            const lastName = res.join();
            const CityData = this.state.values.cityId.split(" ");
            this.data = new URLSearchParams();
            const extras = this.state.values;
            extras.fullName = this.state.values.name;
            extras.firstName = firstNamee;
            extras.lastName = lastName || ' ';
            extras.cityName = CityData[1];
            this.data.append('extras',JSON.stringify(extras));
            this.data.append('campaignName' , this.props.formData.campaignName);
            this.data.append('campaignId' , this.props.formData.campaignId);
            this.data.append('cityId' , CityData[0]);
            this.data.append('name', this.state.values.name);
            this.data.append('mobile' , this.state.values.mobile);
            this.data.append('email' , this.state.values.email);
            if((this.props.formData || {}).OTPCheck) {
                this.setState({
                    showOtpForm: true
                });

            } else {
                this.apiCall(this.data);
            }
        } 
       //event.preventDefault();
    }
    leadSubmit = () => {
       this.apiCall(this.data);
    }
    apiCall = (data) => {
        const params = {
            url : apiUrl + '/lead-generation/rawlead?aj=1',
            data : data
        }
        this.apiHelper.request('post', params).then((response) => {
            this.setState({success: true, showOtpForm: false});
        });
    }
    render(props){
        if(props.formData) {
        const { success, showOtpForm } = this.state;
        return(
            <div class="bmw-form">
            {!success && !showOtpForm &&
            <form>
                <h5>{props.formData.formTitle}</h5>
                <List>
                    {props.formData.textFields.map((data, index) => {
                        {return (index == 0 || index == 1) ?
                            (<ListItem class={index == 0 ?  'salutation' : ''}>
                            {data.name == "salutation" ?
                                <div class="qc__custom-select">
                                    <div>
                                        <select hintText={data.name} name={data.name} onChange={this.onInput(data.name)}>
                                            {data.values.map((selectVal) => <option value={selectVal.id}>{selectVal.value}</option> )}
                                        </select>
                                    </div>
                                </div> 
                            :
                           data.name == "name" &&  <Textfield  onChange={this.onInput(data.name)} error={this.state.errors[data.name]} name={data.name} value={this.state.values[data.name]}  fullWidth type={data.type} label={data.labelName} required /> }
                            
                            </ListItem>)
                        :
                         (data.type == "text" || data.type == "number") ?
                            (<ListItem>
                            <Textfield onChange={this.onInput(data.name)} maxLength={data.name == 'mobile' ? 10 : 40} error={this.state.errors[data.name]} name={data.name} value={this.state.values[data.name]} fullWidth type={data.type} label={data.labelName} required />
                        </ListItem>)
                        :
                        (<ListItem>
	                        <div class={this.state.errors[data.name] ? 'qc__custom-select error' : 'qc__custom-select'}>
	                            <div>
	                                <select hintText={data.name} name={data.name} onChange={this.onInput(data.name)}>
	                                   { data.values.map((selectData) => <option value={selectData.id}>{selectData.value}</option> )}
	                                   
	                                </select>
	                            </div>
	                        </div>
                        </ListItem>)
                        }
                    })}
                    <ListItem class="qc__termstext">By proceeding, you agree to our <a href="/html/termsandconditions.php" target="_blank" >Terms of Use</a> and <a href="/html/policies.php#privacy-policy" target="_blank">Privacy Policy</a></ListItem>
                    <ListItem>
                        <Button primary stroked unelevated full={true} onClick={this.submitForm} ripple={true}>{props.formData.buttonName}</Button>
                    </ListItem> 
                </List>
            </form>
            }
            {showOtpForm && <div class="otpForm">
                <Otp openInput={this.backBtn} mobile={this.state.values.mobile} csrf={{
                    key: 'cars_test_drive',
                    ftoken: props.formData.fToken,
                    value: props.formData.csrf
                }} successCallBack={this.leadSubmit} />
            </div>}
            {success && !showOtpForm &&  
                <div class="successMessage">
                <img src="https://teja10.kuikr.com/QuikrCars/Cars/assets/bikePoint.png" alt="success" />
                <h1>Thank you for your interest. We will connect with you soon.</h1>
                </div>
            }
        </div>
        )
    }
    }
}
export default PartnershipForm;



// WEBPACK FOOTER //
// ../q-cars/src/components/common/Partnerships/form/index.js